let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("2F69B"), load("agA4G")]).then(() => parcelRequire('4E9c2'));